import React, { useEffect, useContext, useState, useMemo } from "react";
import { lib } from "../index";
import "./account.less";
import { Checkbox, Button, message, Tabs, Tooltip, Space } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import TableComponent, { WrapCheckbox } from "./permission-table";

function getMaxLevel(list, checkSet) {
    let maxLevel = 1;

    function getNum(item, level = 0) {
        maxLevel = Math.max(maxLevel, level);
        item.num = 0;
        if (item.list && item.list.length > 0 && item.list[0].id) {
            item.list.map(child => {
                item.num += getNum(child, level + 1);
            });
        } else {
            item.num = 1;
        }
        return item.num;
    }

    getNum({ list });
    return maxLevel;
}

function initCheck(list, set) {
    if (!list) {
        return;
    }
    list.map(item => {
        if (item.auth) {
            set.add(item.id);
        }
        initCheck(item.list, set);
        initCheck(item.buttons, set);
    });
}

function PermissionManage() {
    let [checkAccessSet, setSet] = useState(new Set());
    let [detail, setDetail] = useState({});
    let [accessData, setAccessData] = useState([]);
    let systemTarget = lib.config.webToken == "admin" ? "/ucenter-admin" : "/ucenter-customer";
    let systemCode = lib.config.systemCode;
    let roleId = lib.getParam("roleId");
    let isDetail = lib.getParam("isDetail") === "true";

    const RequestMap = [
        [`${systemTarget}/role/details`, setDetail, { systemCode, id: roleId }], // 获取角色详情
    ];

    function freshData([url, success, data]) {
        lib.request({
            url,
            data,
            needMask: true,
            success,
        });
    }

    function fetchData() {
        lib.request({
            url: `${systemTarget}/role/data/dataTree`,
            data: {
                systemCode,
                roleId: roleId,
            },
            needMask: true,
            success: res => {
                let data = res;
                setAccessData(() => {
                    let list = getAllAuthList(data);
                    setSet(new Set(list));
                    translateData(data);
                    checkStatus(data, list);
                    return data;
                });
            },
        });
    }

    let showSystems = [
        "CCS_ADMIN",
        "UCENTER_CONFIG",
        "ACCOUNT_WEB",
        "ARES_WEB",
        "ARES_ADMIN",
        "ACCOUNT_ADMIN",
        "BMS_WEB",
        "ATTENDANCE",
        "DT_WMS",
    ];
    if (lib.config.env !== "online") {
    }
    useEffect(() => {
        RequestMap.map(([url, success, data]) => freshData([url, success, data]));
        showSystems.includes(systemCode) && fetchData();
    }, []);

    let tabsItems = [
        {
            label: "菜单权限",
            key: "0",
            children: <TableComponent />,
        },
    ];
    if (showSystems.includes(systemCode)) {
        tabsItems.push({
            label: "数据权限",
            key: "1",
            children: (
                <AccessData
                    {...{ accessData, setAccessData, checkAccessSet, setSet, systemTarget, roleId, fetchData }}
                />
            ),
        });
    }

    return (
        <div className="react-single-app-permission-manage">
            {!isDetail ? (
                <div className="page-title">
                    正在为<span>{detail.systemName}</span>系统分配角色权限
                </div>
            ) : null}
            <div className="role-module">
                <div className="role-img">&#xe706;</div>
                <p className="role-name">{detail.name}</p>
                <p className="role-detail">{detail.remark || "暂无相关描述"}</p>
            </div>
            <Tabs defaultActiveKey="0" items={tabsItems} />
        </div>
    );
}

function getAllAuthList(arr) {
    return arr.reduce((prev, curr) => {
        if (curr.auth) {
            prev.push(curr.id);
        }
        if (curr.list?.length) {
            prev = prev.concat(getAllAuthList(curr.list));
        }
        return prev;
    }, []);
}

function checkStatus(data, list) {
    data.map(item => {
        if (item.auth) {
            if (isContain(list, item.childKeys)) {
                item.indeterminate = false;
            } else if (notAnyOne(list, item.childKeys)) {
                item.indeterminate = false;
            } else {
                item.indeterminate = true;
            }
        }
        if (item.list?.length) {
            checkStatus(item.list, list);
        }
    });
}

function translateData(data) {
    data.map(item => {
        item.childKeys = getChildKey(item);
        if (item.list?.length) {
            translateData(item.list);
        }
    });
}

function getTotalLength(data) {
    return data.list.reduce((prev, curr) => (curr.list?.length ? prev + getTotalLength(curr || []) : prev + 1), 0);
}

function findItemChange(value, data) {
    let result = {};
    let a = [];
    a.concat();
    data.map(item => {
        if (item.id == value) {
            result = item;
        } else {
            let res = findItemChange(value, item?.list || []);
            if (res.code) {
                result = res;
            }
        }
    });
    return result;
}

function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}

function changeParent(parentId, accessData, bool) {
    let parent = findItemChange(parentId, accessData);
    parent.indeterminate = bool;
    if (parent.parentId) {
        changeParent(parent.parentId, accessData, bool);
    }
}

function batchChange(arr) {
    arr.map(item => {
        item.indeterminate = false;
        if (item.list?.length) {
            batchChange(item.list);
        }
    });
}

// 判断A数组是否完全包含B数组
function isContain(arr, brr) {
    return brr.every(item => ~arr.indexOf(item));
}

// 判断A数组是否完全没有B数组
function notAnyOne(arr, brr) {
    return brr.every(item => arr.indexOf(item) === -1);
}

// 获取所有子节点regionId
function getChildKey(obj) {
    return (
        obj.list?.reduce((prev, curr) => {
            if (curr.id) {
                return prev.concat([curr.id], getChildKey(curr));
            } else {
                return prev.concat(getChildKey(curr));
            }
        }, []) || []
    );
}

function AccessData({ accessData, setAccessData, checkAccessSet, setSet, systemTarget, roleId, fetchData }) {
    let isDetail = lib.getParam("isDetail") === "true";

    // 过滤数据：详情模式下只显示 auth === 1 的节点
    const filteredData = useMemo(() => {
        if (!isDetail) return accessData;

        function filterByAuth(items) {
            if (!items || items.length === 0) return [];

            return items
                .filter(item => item.auth === 1)
                .map(item => ({
                    ...item,
                    list: item.list ? filterByAuth(item.list) : [],
                }));
        }

        return filterByAuth(accessData);
    }, [accessData, isDetail]);

    // 计算树的最大层级
    const maxLevel = useMemo(() => {
        if (!filteredData || filteredData.length === 0) return 1;
        let max = 1;
        function calcLevel(items, level = 1) {
            items.forEach(item => {
                max = Math.max(max, level);
                if (item.list && item.list.length > 0 && item.list[0].id) {
                    calcLevel(item.list, level + 1);
                }
            });
        }
        calcLevel(filteredData);
        return max;
    }, [filteredData]);

    // 动态生成表头
    const tableHeaders = useMemo(() => {
        const headers = [];
        const levelNames = ["一级", "二级", "三级", "四级", "五级", "六级", "七级", "八级", "九级", "十级"];
        for (let i = 0; i < maxLevel; i++) {
            headers.push(`${levelNames[i] || `${i + 1}级`}数据节点`);
        }
        return headers;
    }, [maxLevel]);

    // 通用的节点变更处理函数
    function handleNodeChange(e, item, ancestors = []) {
        setSet(checkAccessSet => {
            if (e.target.checked) {
                checkAccessSet = new Set([...checkAccessSet, item.id, ...(item.childKeys || [])]);
            } else {
                checkAccessSet = new Set(
                    Array.from(checkAccessSet)
                        .filter(ite => (item.childKeys || []).indexOf(ite) == -1)
                        .filter(ite => ite != item.id),
                );
            }
            // 更新父节点状态
            if (item.parentId && ancestors.length > 0) {
                const parent = ancestors[ancestors.length - 1];
                if (isContain([...checkAccessSet], parent.childKeys)) {
                    checkAccessSet.add(String(item.parentId));
                } else if (notAnyOne([...checkAccessSet], parent.childKeys)) {
                    checkAccessSet.delete(String(item.parentId));
                } else {
                    checkAccessSet.delete(String(item.parentId));
                }
            }

            setAccessData(accessData => {
                accessData = deepClone(accessData);
                let curr = findItemChange(item.id, accessData);
                if (curr) {
                    curr.indeterminate = false;
                }

                // 更新所有祖先节点的indeterminate状态
                ancestors.forEach(ancestor => {
                    let ancestorNode = findItemChange(ancestor.id, accessData);
                    if (ancestorNode) {
                        if (isContain([...checkAccessSet], ancestor.childKeys)) {
                            ancestorNode.indeterminate = false;
                        } else if (notAnyOne([...checkAccessSet], ancestor.childKeys)) {
                            ancestorNode.indeterminate = false;
                        } else {
                            ancestorNode.indeterminate = true;
                        }
                    }
                });

                if (curr && curr.list) {
                    batchChange(curr.list);
                }
                return accessData;
            });

            return new Set([...checkAccessSet]);
        });
    }

    // 将树形数据扁平化为表格行数据
    function flattenTreeToRows(data, level = 1, ancestors = []) {
        const rows = [];

        if (!data || data.length === 0) {
            return rows;
        }

        data.forEach(item => {
            const currentAncestors = [...ancestors, item];

            // 如果是最后一级之前的一级（倒数第二级）
            if (level === maxLevel - 1 && maxLevel > 1) {
                // 获取所有叶子节点（最后一级）
                const leafNodes = item.list && item.list.length > 0 && item.list[0].id ? item.list : [];

                // 如果有叶子节点，创建一行
                if (leafNodes.length > 0) {
                    rows.push({
                        ancestors: ancestors,
                        current: item,
                        leaves: leafNodes,
                        level: level,
                    });
                } else {
                    // 如果没有叶子节点，当前节点就是最后一级
                    rows.push({
                        ancestors: ancestors,
                        current: item,
                        leaves: [],
                        level: level,
                    });
                }
            } else if (level < maxLevel - 1) {
                // 继续递归
                const childRows = flattenTreeToRows(item.list || [], level + 1, currentAncestors);
                if (childRows.length > 0) {
                    rows.push(...childRows);
                } else {
                    // 如果没有子节点，当前节点就是叶子节点
                    rows.push({
                        ancestors: ancestors,
                        current: item,
                        leaves: [],
                        level: level,
                    });
                }
            } else if (level === maxLevel) {
                // 如果已经是最后一级（没有子节点的情况）或者只有一级
                rows.push({
                    ancestors: ancestors,
                    current: item,
                    leaves: [],
                    level: level,
                });
            }
        });

        return rows;
    }

    const flatRows = useMemo(() => flattenTreeToRows(filteredData, 1, []), [filteredData, maxLevel]);
    console.log("flatRows", flatRows);

    return (
        <div className="data-access">
            <Checkbox.Group value={[...checkAccessSet]}>
                <table>
                    <thead>
                        <tr>
                            {tableHeaders.map((header, index) => (
                                <th key={index}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {flatRows.map((row, rowIndex) => {
                            // 用于跟踪已渲染的列数
                            const renderedCells = [];

                            // 渲染所有祖先节点
                            row.ancestors.forEach((ancestor, ancestorIndex) => {
                                // 检查是否应该渲染这个单元格（避免重复）
                                const shouldRender =
                                    rowIndex === 0 ||
                                    (rowIndex > 0 && flatRows[rowIndex - 1].ancestors[ancestorIndex] !== ancestor);

                                if (shouldRender) {
                                    // 计算rowSpan：统计后续有多少行共享同一个祖先
                                    let rowSpan = 1;
                                    for (let i = rowIndex + 1; i < flatRows.length; i++) {
                                        if (flatRows[i].ancestors[ancestorIndex] === ancestor) {
                                            rowSpan++;
                                        } else {
                                            break;
                                        }
                                    }

                                    renderedCells.push(
                                        <td key={`ancestor-${ancestorIndex}`} rowSpan={rowSpan}>
                                            <WrapCheckbox
                                                isDetail={isDetail}
                                                indeterminate={ancestor.indeterminate}
                                                value={ancestor.id}
                                                onChange={e =>
                                                    handleNodeChange(e, ancestor, row.ancestors.slice(0, ancestorIndex))
                                                }>
                                                {ancestor.name}
                                                {ancestor.remark && (
                                                    <Tooltip title={ancestor.remark}>
                                                        <QuestionCircleOutlined style={{ marginLeft: 4 }} />
                                                    </Tooltip>
                                                )}
                                            </WrapCheckbox>
                                        </td>,
                                    );
                                }
                            });

                            // 计算还需要多少列来填充到maxLevel
                            const ancestorColumns = row.ancestors.length;
                            const remainingColumns = maxLevel - ancestorColumns;

                            // 渲染当前节点
                            if (remainingColumns > 0) {
                                renderedCells.push(
                                    <td key="current">
                                        {row.current.name && (
                                            <WrapCheckbox
                                                isDetail={isDetail}
                                                indeterminate={row.current.indeterminate}
                                                value={row.current.id}
                                                onChange={e => handleNodeChange(e, row.current, row.ancestors)}>
                                                {row.current.name}
                                                {row.current.remark && (
                                                    <Tooltip title={row.current.remark}>
                                                        <QuestionCircleOutlined style={{ marginLeft: 4 }} />
                                                    </Tooltip>
                                                )}
                                            </WrapCheckbox>
                                        )}
                                    </td>,
                                );
                            }

                            // 如果有叶子节点且还有剩余列，渲染叶子节点
                            if (remainingColumns > 1 && row.leaves.length > 0) {
                                renderedCells.push(
                                    <td key="leaves">
                                        <Space wrap style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                                            {row.leaves.map(
                                                (leaf, leafIndex) =>
                                                    leaf.name && (
                                                        <WrapCheckbox
                                                            key={leafIndex}
                                                            isDetail={isDetail}
                                                            value={leaf.id}
                                                            onChange={e =>
                                                                handleNodeChange(e, leaf, [
                                                                    ...row.ancestors,
                                                                    row.current,
                                                                ])
                                                            }>
                                                            {leaf.name}
                                                            {leaf.remark && (
                                                                <Tooltip title={leaf.remark}>
                                                                    <QuestionCircleOutlined style={{ marginLeft: 4 }} />
                                                                </Tooltip>
                                                            )}
                                                        </WrapCheckbox>
                                                    ),
                                            )}
                                        </Space>
                                    </td>,
                                );
                            } else if (remainingColumns > 1 && row.leaves.length === 0) {
                                // 如果没有叶子节点但需要填充列，添加空单元格
                                renderedCells.push(<td key="leaves"></td>);
                            }

                            return <tr key={rowIndex}>{renderedCells}</tr>;
                        })}
                    </tbody>
                </table>
                {!isDetail && (
                    <div className="ft">
                        <Button
                            type="primary"
                            style={{ width: "120px" }}
                            onClick={() => {
                                lib.request({
                                    url: `${systemTarget}/role/data/update`,
                                    data: {
                                        roleId,
                                        dataId: removeDuplicate([...checkAccessSet, ...getAllId(accessData)]),
                                    },
                                    needMask: true,
                                    success: () => {
                                        message.success("操作成功");
                                        fetchData();
                                    },
                                });
                            }}>
                            保存
                        </Button>
                    </div>
                )}
            </Checkbox.Group>
        </div>
    );
}

function removeDuplicate(arr) {
    return Array.from(new Set(arr));
}

function getAllId(data) {
    return data.reduce((prev, item) => {
        if (item.indeterminate) {
            prev.push(item.id);
        }
        if (item.list?.length) {
            prev = prev.concat(getAllId(item.list));
        }
        return prev;
    }, []);
}

export default PermissionManage;
